import React, { FC } from 'react';
import VariantSliderContainer from '../customiseDisplay/variantSliderContainer/VariantSliderContainer';
import CustomiseErrorBoundary from './CustomiseErrorBoundary';
import BaseConfiguratorLayout from '../../../../common/components/layouts/baseConfiguratorLayout/BaseConfiguratorLayout';
import CustomiseControls from '../customiseControls/CustomiseControls';
import CustomiseMobileActions from './CustomiseMobileActions';
import StickyFooterContainer from '../footer/StickyFooterContainer';
import DisclaimerContainer from '../disclaimer/DisclaimerContainer';
import NavigationBarContainer from '../../../../common/components/navigation/NavigationBarContainer';

const CustomiseLayout: FC = () => {
  return (
    <CustomiseErrorBoundary>
      <BaseConfiguratorLayout
        navigationSlot={<NavigationBarContainer />}
        leftSlot={<VariantSliderContainer />}
        footerSlot={<StickyFooterContainer />}
        disclaimerSlot={<DisclaimerContainer />}
        rightSlot={
          <>
            <CustomiseControls />
            <CustomiseMobileActions />
          </>
        }
      />
    </CustomiseErrorBoundary>
  );
};

export default CustomiseLayout;
